import Meta from 'src/components/meta/Meta';

const PortfolioMeta = () => <Meta
  title="My Portfolio | Property Investment | BrickX"
/>;

export default PortfolioMeta;
